(function($){
    if($('#offer').length > 0){
        if($(window).width() > 1024){
            if($('#offer .left > img').height() > $('#offer .right .offer').height()){
                $('#offer .left > img').height($('#offer .right .offer').height());
            }
        }
    }
})(jQuery)